import React, { memo } from 'react'
import classNames from 'classnames'
import { FormattedDateTime } from 'transfix-ui/components/FormattedDateTime'
import { MapMarker } from 'transfix-ui/components/MapMarker'
import { useStopSummaryItem } from 'apps/fleet-planner/components/load-details/stops/StopsSummaryStyles'
import { IStop } from 'apps/fleet-planner/types'
import { capitalize } from 'utils/capitalize'
import { formatCityState } from 'utils/formatCityState'
import { AllowedTimezones } from 'constants/AllowedTimezones'

interface IStopSummaryProps {
  stop?: IStop
  stopNumber: number
  className?: string
  compact?: boolean
}

export const StopSummaryItem = memo<IStopSummaryProps>(
  ({ className, compact = false, stop, stopNumber }) => {
    const { address, displayTimezone, facility, startAt = '', stopType } = stop || {}
    const { name } = facility || {}
    const timezone = displayTimezone as AllowedTimezones
    const { locality = '', subdivisionCode = '' } = address || {}
    const styles = useStopSummaryItem({ compact })
    const classes = classNames(styles.root, className)

    return (
      <div className={classes}>
        <div className={styles.symbol}>
          <MapMarker type={stopType} sequence={stopNumber} />
        </div>
        <div>
          <div className='body-large'>{name || capitalize(locality)}</div>
          <span className='body-medium'>{formatCityState(locality, subdivisionCode)} </span>
          <FormattedDateTime
            className='body-bold'
            datetime={startAt}
            displayTimezone={timezone}
            showTimezone
            format='timeWeekdayDateAndYear'
            timeShort
            abbreviated
          />
        </div>
      </div>
    )
  }
)
